import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

export function NewPOAWhenToMake() {
  const navigate = useNavigate();
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../intro-screen');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../when-effective');
  }, [ navigate ]);
  
  return (
    <div className="new-poa-when-to-make screen-container screen">
      <ScreenHeader
        title="When to Make a Power of Attorney"
        description="Understanding the best times to create this important document"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>Why Create a Power of Attorney Now?</h3>
        <p>
          It's important to create a Power of Attorney while you're healthy and able to make 
          sound decisions. Here are the key reasons why:
        </p>
        
        <ul className="benefits-list">
          <li>
            <strong>Peace of Mind:</strong> You'll have a plan in place if something unexpected happens
          </li>
          <li>
            <strong>Prevents Court Intervention:</strong> Without a POA, your family may need to go 
            to court to get permission to handle your finances
          </li>
          <li>
            <strong>Maintains Control:</strong> You choose who will make decisions for you, rather 
            than leaving it to a judge
          </li>
          <li>
            <strong>Cost Effective:</strong> Creating a POA now is much less expensive than 
            court proceedings later
          </li>
          <li>
            <strong>Immediate Effect:</strong> Your agent can act right away if needed, without delays
          </li>
        </ul>

        <h3>When You Should Consider Creating a POA</h3>
        <ul className="timing-list">
          <li>When you turn 18 and become legally responsible for your own affairs</li>
          <li>Before major life changes like marriage, divorce, or having children</li>
          <li>When you start a business or make significant investments</li>
          <li>Before traveling extensively or living abroad</li>
          <li>As part of comprehensive estate planning</li>
          <li>When you notice any decline in your ability to manage complex financial matters</li>
        </ul>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            You cannot create a Power of Attorney after you've lost the mental capacity to make 
            decisions. That's why it's crucial to create one while you're healthy and thinking clearly.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
